/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWGameSteamDataPcRequirements
 */
export interface OWGameSteamDataPcRequirements {
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamDataPcRequirements
     */
    minimum?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamDataPcRequirements
     */
    recommended?: string;
}

/**
 * Check if a given object implements the OWGameSteamDataPcRequirements interface.
 */
export function instanceOfOWGameSteamDataPcRequirements(value: object): value is OWGameSteamDataPcRequirements {
    return true;
}

export function OWGameSteamDataPcRequirementsFromJSON(json: any): OWGameSteamDataPcRequirements {
    return OWGameSteamDataPcRequirementsFromJSONTyped(json, false);
}

export function OWGameSteamDataPcRequirementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSteamDataPcRequirements {
    if (json == null) {
        return json;
    }
    return {
        
        'minimum': json['minimum'] == null ? undefined : json['minimum'],
        'recommended': json['recommended'] == null ? undefined : json['recommended'],
    };
}

export function OWGameSteamDataPcRequirementsToJSON(json: any): OWGameSteamDataPcRequirements {
    return OWGameSteamDataPcRequirementsToJSONTyped(json, false);
}

export function OWGameSteamDataPcRequirementsToJSONTyped(value?: OWGameSteamDataPcRequirements | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minimum': value['minimum'],
        'recommended': value['recommended'],
    };
}

